import { render, staticRenderFns } from "./AssignmentTableItemChip.vue?vue&type=template&id=03cbe52e&scoped=true&"
import script from "./AssignmentTableItemChip.vue?vue&type=script&lang=js&"
export * from "./AssignmentTableItemChip.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTableItemChip.vue?vue&type=style&index=0&id=03cbe52e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cbe52e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
